import { useQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useConsignmentPDF(consignmentKey: string) {
  return useQuery({
    ...apiClient.getConsignmentPdfUrlConsignmentsKeyPdfGetOptions({
      path: {
        key: consignmentKey,
      },
    }),
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  })
}
